import React, {Component} from "react"

import { fetchDevice } from '../../actions/devices'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { Container, Col, Card, CardBody, CardFooter, CardSubtitle, CardText } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class DeviceInfo extends Component {

	componentDidMount() {
		//console.log(this.props);
		if (!this.props.isLoading) this.props.fetch(this.props.deviceId);
	}

	render() {
		const { isLoading, device } = this.props;

		if (isLoading || device==null) {
			return (
				<Container>
					<h2>Geräteinformationen</h2>
					<p><FontAwesomeIcon icon="spinner" spin /></p>
				</Container>
			)
		}

		const toLog = "/device/"+device.id+"/log";
		return (
			<Container>
				<h2>Geräteinformationen</h2>
				<Col md="12" className="mb-2">
					<Card>
						<CardBody>
							<CardSubtitle><small>ID: {device.id}</small></CardSubtitle>

							Typ: {device.type}<br />
							<CardText>{device.description}</CardText>
						</CardBody>
						<CardFooter className="text-right">
							<Link to={toLog} className="btn btn-primary">Log</Link>
						</CardFooter>
					</Card>
				</Col>
			</Container>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	console.log(ownProps);
	return {
		deviceId: ownProps.deviceId,
		device: state.devices.current,
		isLoading: state.devices.networking
	}
}

const mapDispatchToProps = dispatch => ({
	fetch: (id) => dispatch(fetchDevice(id))
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DeviceInfo)
